import React from 'react';
import { FiFacebook, FiLinkedin, FiInstagram, FiMail, FiGithub } from 'react-icons/fi'

import { images } from '../../constants';
import './Footer.css';

const linkedin = 'https://www.linkedin.com/in/sharad-tembhurne/';
const email = "mailto:%20sharad.tembhurne@nyu.edu";
const github = "https://github.com/sharadTT";
const facebook = "https://www.facebook.com/sharad97";
const instagram = "https://www.instagram.com/chicken._.biryani/";

const Footer = () => (
  <div className='app__footer section__padding' id='contact'>

    <div className='app__footer-links'>
      <div className='app__footer-links_contact'>
        <h1 className='app__footer-headtext'>Contact</h1>
        <div className='app__footer-links_icons'>
          <a href={linkedin} target="_blank" rel="noopener noreferrer">
            <FiLinkedin />
          </a>
          <a href={email} target="_blank" rel="noopener noreferrer">
            <FiMail />
          </a>
          <a href={github} target="_blank" rel="noopener noreferrer">
            <FiGithub />
          </a>
          <a href={facebook} target="_blank" rel="noopener noreferrer">
            <FiFacebook />
          </a>
          <a href={instagram} target="_blank" rel="noopener noreferrer">
            <FiInstagram />
          </a>
        </div>

        <a href={email} target="_blank" rel="noopener noreferrer">
          <p className='p__opensans'>sharad.tembhurne@nyu.edu</p>
          </a>

        
      </div>

      <div className='app__footer-links_logo'>

        <img src={images.gericht} alt="footer logo" />
        <p className='p__opensans'>"If you are not early, you are late"</p>

      </div>

      {/* <div className='app__footer-links_work'>
        <h1 className='app__footer-headtext'>ADD API HERE</h1>
      </div> */}
    </div>

    <div className='footer__copyright'>
      <p className='p__opensans'>© 2023 Sharad Tembhurne</p>
    </div>
  </div>
);

export default Footer;
